export default __webpack_public_path__ + "static/media/j3.864b19c4.png";